__turbopack_context__.v({
  "quoteNewsFeedWrapper": "S-PL2a_quoteNewsFeedWrapper",
});
